import { Injectable } from '@angular/core';
import { UserLocation } from './shared.service';

@Injectable({ providedIn: 'root' })
export class LocationService {
    getLocation(): Promise<UserLocation> {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject("Geolocation not supported");
            } else {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve({
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        });
                    },
                    (err) => reject(err)
                );
            }
        });
    }
}
